import Multiselect from 'multiselect-react-dropdown';
import React from 'react';

export const MultiSelectAnswerField = ({
	options = [],
	selectedOptions = [],
	onAnswerChange
}) => {
	
	return (
		<div>
			<Multiselect
				options={options}
				selectedValues={selectedOptions}
				onSelect={(selectedList, selectedItem) => onAnswerChange(selectedList, selectedItem)}
				onRemove={(selectedList, selectedItem) => onAnswerChange(selectedList, selectedItem)}
				displayValue="name"
			/>
		</div>
	);
};

export default MultiSelectAnswerField;
